import React, { useState } from "react";
import PropTypes from "prop-types";

import { DataGrid } from "@mui/x-data-grid";
import MDBox from 'components/MDBox';
import { isEmpty } from "utils/validationUtil";
import { IconButton } from "@mui/material";
import { Edit, Delete as DeleteIcon } from "components/icons";
import { useResizableColumnWidths } from "app/hooks/useResizableColumnWidths";
import { DEFAULT_TABLE_PAGE_SIZE } from "AppConstants";


export const ActivityTypesDataGrid = (props) => {
    const {activityTypes} = props;
    const [pageSize, setPageSize] = useState(10);

    const columns = [
        {
            field: "actions",
            type: "actions",
            headerName: "Actions",
            width: 100,
            cellClassName: "actions",
            getActions: (obj) => {
                return [
                  <IconButton
                    aria-label="Edit"
                    onClick={() => props.editEventHandler(obj.row)}
                    color="inherit"
                  >
                    <Edit />
                  </IconButton>,
                  <IconButton
                    aria-label="Delete"
                    onClick={() => props.confirmDeleteDialogHandler(obj.row)}
                    color="inherit"
                  >
                    <DeleteIcon />
                  </IconButton>,
                ];
            }, // getAction
          },
        { field: 'id', headerName: 'Id', width: 120 },
        { field: 'activityDesc', headerName: 'Title', width: 360},
        { field: 'Client', headerName: 'Client Name', width: 360, valueGetter: (value, row) => row.client.name  },
        { field: 'order', headerName: 'Order', width: 100 },
    ]

    // Keeps a dragged column width alive across the re-render that editing or deleting a
    // row causes.
    const { columns: sizedColumns, onColumnWidthChange } = useResizableColumnWidths(columns);

    const getData = () => {
        if(isEmpty(activityTypes) || activityTypes.length === 0)
            return [];
        else
            return activityTypes;
    }
    
    return (
        <MDBox py={1.5}
            px={2}
            height={500}
        >
            <DataGrid
                density="compact"
                // sx={{ margin: 2 }}
                rows={ getData() }
                columns={sizedColumns}
                onColumnWidthChange={onColumnWidthChange}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[5, 10, 20]}
                loading={props.isLoading}
                // Id hidden by default; the old `hide: true` column flag no longer exists in DataGrid v8.
                initialState={{
                    columns: { columnVisibilityModel: { id: false } },
                    pagination: { paginationModel: { pageSize: DEFAULT_TABLE_PAGE_SIZE } },
                }}
                // getRowId={(teamMember)=> teamMember.id}
            />
        </MDBox>
    );
}

ActivityTypesDataGrid.propTypes = {
  activityTypes: PropTypes.array.isRequired
}